/**
 * カスタムJS用記述を追加
 */

function customUSAccordionInit(target) {
  const isMobile = window.matchMedia('(max-width: 768px)');
  const targetArray = document.querySelectorAll(target)
  if (!targetArray.length) return;

  const apply = () => {
    targetArray.forEach((target) => {
      if (isMobile.matches) {
        target.removeAttribute('open');
      } else {
        target.setAttribute('open', '');
      }
    });  
  }
  apply();

  let rafId = null;
  const onResize = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      apply();
    });
  };

  window.addEventListener('resize', onResize, { passive: true });
}

/* from message-bar.js */
function customUSMessageBar() {
  const messageWrapper = document.querySelector('#usMessageBar'),
        messageBlock = messageWrapper.querySelector('.message-bar.block'),
        messagesDiv = messageWrapper.querySelector('.messages'),
        messagesTrack = messageWrapper.querySelector('.messages-track');

  if (messagesTrack.children.length > 1) {
    const arrow = messageWrapper.querySelector('.arrow');
    arrow.addEventListener('click', () => {
      const activeMessage = messagesDiv.querySelector('.message.active');
      if (activeMessage) {
        activeMessage.classList.remove('active');
        const nextMessage = activeMessage.nextElementSibling || messagesDiv.querySelector('.message');
        nextMessage.classList.add('active');
        messagesTrack.appendChild(activeMessage);
      }
    });
  }

  const header = document.querySelector('.c-base-us__header .header');
  let isHidden = false;

  window.addEventListener('scroll', () => {
    const shouldHide = window.scrollY >= 100;

    if (shouldHide !== isHidden) {
      messageBlock.classList.toggle('message-bar-hide', shouldHide);
      header.classList.toggle('header-sticky', shouldHide);
      document.body.classList.toggle('c-header-sticky-show', shouldHide);

      const links = header.querySelectorAll('a');
      links.forEach((link) => {
        if (link.hasAttribute('data-rum-source') && link.getAttribute('data-rum-source') === 'header-sticky') {
          link.removeAttribute('data-rum-source');
        } else {
          link.setAttribute('data-rum-source', 'header-sticky');
        }
      });
      isHidden = shouldHide;
    }
  });
}

function customUStab() {
  const tabButtonArray = document.querySelectorAll('.tabs-wrapper button.tabs-tab');
  tabButtonArray.forEach((button, i) => {
    const wrapper = button.closest('.tabs-wrapper'),
          tablist = wrapper.querySelector('.tabs-list'),
          tabpanel = wrapper.querySelectorAll('.tabs-panel')[i];

    button.addEventListener('click', () => {
      wrapper.querySelectorAll('[role=tabpanel]').forEach((panel) => {
        panel.setAttribute('aria-hidden', true);
      });
      tablist.querySelectorAll('button').forEach((btn) => {
        btn.setAttribute('aria-selected', false);
      });
      tabpanel.setAttribute('aria-hidden', false);
      button.setAttribute('aria-selected', true);
    });
  })
}


document.addEventListener( 'DOMContentLoaded', function() {
  customUSMessageBar();
  customUStab();
  customUSAccordionInit('.footer-wrapper details.footer-accordion');
} );
